<template>
  <b-card :id="'id-' + location.id" no-body class="w-100">
    <b-card-body>
      <address v-for="(address, aIndex) in location.physical_addresses" :key="aIndex">
        <!-- <span v-if="location.name">{{ location.name }}<br /></span> -->
        <router-link
          :to="{
            name: 'Location',
            params: {
              id: location.id,
              name: encodeURIComponent(location.name),
            },
          }"
          aria-label="View service information"
          itemprop="url"
        >
          <h4>{{ location.name }}</h4>
        </router-link>
        <span v-if="address.address_1">{{ address.address_1 }}<br /></span>
        <span v-if="address.city">{{ address.city }}<br /></span>
        <span v-if="address.state_province">{{ address.state_province }}<br /></span>
        <span v-if="address.postal_code">{{ address.postal_code }}<br /></span>
      </address>
      <span
        v-if="
          location.accessibility_for_disabilities &&
          location.accessibility_for_disabilities[0].accessibility != 'false' &&
          location.accessibility_for_disabilities[0].accessibility.length > 1
        "
      >
        Accessibility:
        <ul>
          <li
            v-for="(access, index) in location.accessibility_for_disabilities"
            :key="index"
            class="accessibility"
          >
            {{ access.accessibility.replace(/-/gi, ' ') }}
          </li>
        </ul>
      </span>

      <router-link
        :to="{
          name: 'Location',
          params: {
            id: location.id,
            name: encodeURIComponent(location.name),
          },
        }"
        aria-label="View location information"
        itemprop="url"
      >
        View location information
      </router-link>
    </b-card-body>
  </b-card>
</template>

<script>
export default {
  name: 'LocationListItem',
  props: {
    location: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  computed: {
    displayInfo() {
      // if (typeof locations == 'undefined') return false
      // if (locations && locations[0] && locations[0].location.physical_addresses) return true
      return true
    },
  },
}
</script>
<style>
.accessibility {
  text-transform: capitalize;
}
</style>